// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.fees.multifamily.disclaimer.RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { AddMultifamilyFeeDisclaimerRequestDto, UpdateMultifamilyFeeDisclaimerRequestDto } from '../..';

export const RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create_Path =
  '/api/web/v1/users/properties/fees/multifamily/disclaimer/create';

/**
 * Add a fee disclaimer for a multi family listing
 */
export const RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create = (
  postData: AddMultifamilyFeeDisclaimerRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AddMultifamilyFeeDisclaimerRequestDto, void>(
    {
      endpoint: RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update_Path =
  '/api/web/v1/users/properties/fees/multifamily/disclaimer/update';

/**
 * Update a fee disclaimer for a multi family listing
 */
export const RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update = (
  postData: UpdateMultifamilyFeeDisclaimerRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdateMultifamilyFeeDisclaimerRequestDto, void>(
    {
      endpoint: RentalManagerUserMultifamilyCostAndFeesDisclaimerWebApiHandler_update_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
